import type { CalendarItem, CalendarEvent, DataResponse } from '@pms/shared';
import { api } from '@/lib/api';

export interface GetCalendarItemsQuery {
  start_date: string;
  end_date: string;
  types?: string;
}

export interface CreateCalendarEventInput {
  title: string;
  description?: string | null;
  start_at: string;
  end_at: string;
  all_day?: boolean;
  color?: string | null;
  location?: string | null;
  is_reminder?: boolean;
  reminder_minutes?: number | null;
  visibility?: 'private' | 'team' | 'all';
}

export const calendarService = {
  async getItems(query: GetCalendarItemsQuery): Promise<CalendarItem[]> {
    const res = await api.get<DataResponse<CalendarItem[]>>('/calendar/items', { params: query });
    return res.data.data;
  },

  async createEvent(input: CreateCalendarEventInput): Promise<CalendarEvent> {
    const res = await api.post<DataResponse<CalendarEvent>>('/calendar/events', input);
    return res.data.data;
  },

  async updateEvent(id: string, input: Partial<CreateCalendarEventInput>): Promise<CalendarEvent> {
    const res = await api.patch<DataResponse<CalendarEvent>>(`/calendar/events/${id}`, input);
    return res.data.data;
  },

  async deleteEvent(id: string): Promise<void> {
    await api.delete(`/calendar/events/${id}`);
  },
};
